import { useCookies } from "vue3-cookies";

// Who is signed in, from the cookies sign-in leaves.
const { cookies } = useCookies();

export function currentUser() {
  return cookies.get("user") || {};
}

export function fullName(u) {
  u = u || currentUser();
  return `${u.first_name || ""} ${u.last_name || ""}`.trim();
}

export function signedIn() {
  return !!(cookies.get("token") && cookies.get("api_key"));
}

// remember keeps a sign-in's answer in the cookies. school is the one chosen on
// the sign-in page, when there was one.
export function remember(data, school) {
  const user = data.user;
  delete user.permissions;
  cookies.set("api_key", data.api_token);
  cookies.set("token", data.token);
  cookies.set("user", user);
  cookies.set("role", user.role);
  cookies.set("type", (user.school && user.school.type) || (school && school.type));
}

export function forget() {
  ["token", "api_key", "user", "role", "type"].forEach((k) => cookies.remove(k));
}
